import { keys, uniqBy } from "lodash";

export const filterBy = (columns: string[], text?: string) =>
  columns.reduce((acc, column) => {
    acc[column] = text || undefined;
    return acc;
  }, {} as { [key: string]: string | undefined });

export const normalizeSort = (sort?: string, direction?: "ASC" | "DESC") =>
  sort ? `${direction === "ASC" ? "" : "-"}${sort}` : undefined;

export const combineFilters = (filters?: any[]) =>
  filters &&
  filters.reduce(
    (acc: any, curr: any) => {
      const filterKeys = keys(curr.filter);
      filterKeys.forEach(key => {
        if (typeof curr.filter[key] === "string") {
          if (acc[key]) {
            acc[key] = [...acc[key], curr.filter[key]];
          } else {
            acc[key] = [curr.filter[key]];
          }
        } else {
          acc[key] = curr.filter[key];
        }
      });
      return acc;
    },
    {} as {
      [key: string]: string | string[] | undefined;
    },
  );

export const filterList = (list: any[], attribute: string, filters: any[]) =>
  uniqBy<any>(list, `attributes.${attribute}`)
    .filter(item => item.attributes && item.attributes[attribute])
    .filter(
      item =>
        !filters.some(
          filter => filter.type === item.type && filter.id === item.id,
        ),
    );

export const diffList = (list: any[], filters: any[]) =>
  list.filter(
    item =>
      !filters.some(
        filter => filter.type === item.type && filter.id === item.id,
      ),
  );
